import { RECEIVE_STATION } from "../actions/weatherStationActions";
import {
  REQUEST_STATIONS,
  RECEIVE_STATIONS,
  FAILED_STATIONS,
  SELECT_STATION,
} from "./../actions/weatherStationsActions";

export function weatherStations(
  state = {
    isFetching: false,
    loadError: false,
    selectedStation: null,
    items: [],
  },
  action
) {
  switch (action.type) {
    case RECEIVE_STATION:
      return Object.assign({}, state, {
        isFetching: false,
      });
    case REQUEST_STATIONS:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_STATIONS:
      return Object.assign({}, state, {
        items: action.stations,
      });
    case SELECT_STATION:
      return Object.assign({}, state, {
        selectedStation: action.stationId,
      });
    case FAILED_STATIONS:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    default:
      return state;
  }
}
